import { Company, CompanyRole } from '@app/company/models';

export function getCompanyOrderRole(company: Company): CompanyRole {
  if (company.roles.includes(CompanyRole.BUYER)) {
    return CompanyRole.BUYER;
  }

  return CompanyRole.SUPPLIER;
}
